/* eslint-disable no-async-promise-executor */

import { PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import Vue from 'vue';
import Router from '../router';
import Store from '@/state/store';
import { redirectIfPreview } from '@/utils/previewRedirect';

export default class MsalBrowserUtil {
  tenant = 'webcab.onmicrosoft.com';

  msalConfig = {
    auth: {
      clientId: 'ec8932c2-a513-48a2-945b-4b5a9a35c1b1',
      redirectUri: process.env.VUE_APP_REDIRECT_URL,
      authority:
        'https://webcab.b2clogin.com/webcab.onmicrosoft.com/B2C_1_Signin',
      knownAuthorities: ['webcab.b2clogin.com'],
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  };

  accountIdPublic = '';
  currentAccount = null;

  accessToken = '';
  idToken = '';
  msalInstance = {};

  scopes = [
    'https://webcab.onmicrosoft.com/94282643-db82-4e36-b2c6-b333d89957d6/rw',
  ];

  tokenRequest = {
    scopes: this.scopes,
  };

  loginRequest = {
    scopes: this.scopes,
  };

  constructor(redirectUrl) {
    this.msalConfig.auth.redirectUri = redirectUrl;

    this.msalInstance = new PublicClientApplication(this.msalConfig);
  }

  async init() {
    let promise = new Promise(async (accept, reject) => {
      this.msalInstance
        .handleRedirectPromise()
        .then(
          async (response) => {
            try {
              await this.handleResponse(response);
            } catch (error) {
              // eslint-disable-next-line no-console
              console.log(error);
            }
            accept();
          },
          async (e) => {
            // eslint-disable-next-line no-console
            console.log(e);
            reject();
          }
        )
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e);
        });
    });

    return promise;
  }

  login() {}

  logout() {
    let logoutRequest = {
      account: this.msalInstance.getAccountByLocalId(this.accountIdPublic),
    };
    this.msalInstance.logoutRedirect(logoutRequest);
  }

  setAccountData(data) {
    const currentAccounts = this.msalInstance.getAllAccounts();
    this.accountIdPublic = currentAccounts[0].localAccountId;
    this.currentAccount = currentAccounts[0];
    this.accessToken = data.accessToken;
    this.idToken = data.idToken;
  }

  async getToken() {
    let currentAccounts = this.msalInstance.getAllAccounts();
    let request = {
      scopes: this.scopes,
      account: currentAccounts,
    };

    let promise = this.msalInstance.acquireTokenSilent(request).then(
      (response) => {
        this.setAccountData(response);

        return response.accessToken;
      },
      () => {
        //error send to log in
        this.msalInstance.loginRedirect(this.loginRequest);
      }
    );

    return promise;
  }

  async setTokenResponse(response) {
    return new Promise(async (accept) => {
      this.setAccountData(response);
      // First thing after we have a token: check if this organisation should be
      // routed to the preview deployment. If so, redirect and stop loading.
      try {
        const envRes = await axios.get(
          `${process.env.VUE_APP_API_URL}application/environment`,
          { headers: { authorization: 'Bearer ' + this.accessToken } }
        );
        if (redirectIfPreview(envRes.data.environment)) {
          return; // navigating away to preview host
        }
      } catch (e) {
        // fail open: stay on the current environment
        // eslint-disable-next-line no-console
        console.log(e);
      }

      await this.loadUserConfig();
      await this.loadCache();

      Object.assign(Vue.prototype.$axiosMainClient.defaults, {
        headers: {
          authorization: 'Bearer ' + this.accessToken,
        },
      });

      accept();
    });
  }

  async loadCache() {
    let prom1 = Store.dispatch('cache/fetchSuppliers');
    let prom2 = Store.dispatch('cache/fetchCategories');
    let prom3 = Store.dispatch('cache/fetchCategoryTypes');
    let prom4 = Store.dispatch('cache/fetchAlerts');
    let prom5 = Store.dispatch('cache/fetchOrdersConfig');
    let prom6 = Store.dispatch('cache/fetchOrganizationConfig');
    let prom7 = Store.dispatch('cache/fetchAppInfos');

    await Promise.all([prom1, prom2, prom3, prom4, prom5, prom6, prom7]);
  }

  async loadUserConfig() {
    await Store.dispatch('user/fetchUserConfig', this.accountIdPublic);
    await Store.dispatch('layout/fetchMenuCondensed');
  }

  handleResponse = async (response) => {
    if (response !== null) {
      await this.setTokenResponse(response);
      Router.replace('/');
    } else {
      // In case multiple accounts exist, you can select
      const currentAccounts = this.msalInstance.getAllAccounts();

      if (currentAccounts.length === 0) {
        // no accounts signed-in, attempt to sign a user in
        await this.msalInstance.loginRedirect(this.loginRequest);
      } else if (currentAccounts.length > 1) {
        // Add choose account code here
      } else if (currentAccounts.length === 1) {
        let request = (this.msalInstance.SilentRequest = {
          scopes: this.scopes,
          account: currentAccounts,
        });
        let promise = this.msalInstance.acquireTokenSilent(request).then(
          async (response) => {
            await this.setTokenResponse(response);
          },
          async () => {
            //error send to log in
            await this.msalInstance.loginRedirect(this.loginRequest);
          }
        );

        await promise;
      }
    }
  };
}

/* eslint-enable no-async-promise-executor */
